import React from 'react';
import { View, Text } from 'react-native';
import SelectInput from './inputs/SelectInput';
var LengthMenu = function LengthMenu(_ref) {
  var pageLength = _ref.pageLength,
    updateEntries = _ref.updateEntries,
    options = _ref.options;
  return /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: 'row',
      alignItems: 'baseline'
    }
  }, /*#__PURE__*/React.createElement(Text, null, "Show "), /*#__PURE__*/React.createElement(SelectInput, {
    value: pageLength,
    onChange: function onChange(value) {
      return updateEntries({
        newPageLength: parseInt(value)
      });
    },
    options: options.map(function (length) {
      return {
        value: parseInt(length) || 0,
        label: length
      };
    })
  }), /*#__PURE__*/React.createElement(Text, null, " entries"));
};
export default LengthMenu;